import apiClient from "./api";

/**
 * A per-user access token as shown in the admin UI — never carries the hash or plaintext.
 * Tokens are minted by end-users through the credential exchange (POST /api/autonomous/token);
 * the admin panel only lists and revokes them.
 */
export interface AutonomousApiToken {
  id: string;
  name: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  /**
   * The end-user's external id this token is bound to — runs it triggers are attributed to
   * that user. May be null only for legacy tokens issued before per-user attribution.
   */
  customerExternalId: string | null;
}

export const autonomousTokenService = {
  getAll: (): Promise<AutonomousApiToken[]> =>
    apiClient.get("/autonomous-tokens").then((r) => r.data),

  revoke: (id: string): Promise<void> =>
    apiClient.delete(`/autonomous-tokens/${id}`).then((r) => r.data),
};
